import loopCreate from './loopCreate.js';
import loopFix from './loopFix.js';
import loopDestroy from './loopDestroy.js';
export default {
  loopCreate,
  loopFix,
  loopDestroy
};


//////////////////
// WEBPACK FOOTER
// /Users/mac-10/vvv-local/www/cinqfontaines.test/public_html/wp-content/themes/cinqfontaines/node_modules/swiper/core/loop/index.js
// module id = 65
// module chunks = 0